import {createApp} from 'vue'
import App from './App.vue'

// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
import '@/assets/main.css'


createApp(App).mount('#app')
